import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from './axios';
import interceptors from './axios/interceptors';
import BeeComponents from '@beetronix/bee-components';
import eStorage from './plugins/eStorage';
import i18n from './i18n';
import $eventBus from './utils/event-bus';
import './utils/directives';

import Tooltip from '@/components/global/Tooltip.vue';
import VDeleteDialog from '@/components/global/VDeleteDialog.vue';
import BAsyncInput from '@/components/global/BAsyncInput';
import CustomizableTable from '@/components/global/CustomizableTable';
import BSearch from '@/components/global/BSearch';
import VueMeta from 'vue-meta';

// import firebase from 'firebase/app'
import { eStorage as storage } from '@beetronix/estorage'
interceptors(axios, store, router);

Vue.use(BeeComponents);
Vue.use(VueMeta);

Vue.component('Tooltip', Tooltip);
Vue.component('VDeleteDialog', VDeleteDialog);
Vue.component('BAsyncInput', BAsyncInput);
Vue.component('CustomizableTable', CustomizableTable);
Vue.component('BSearch', BSearch);

Vue.prototype.$eventBus = $eventBus;

Vue.config.productionTip = false;

if (storage.l.has('auth')) {
	const auth = storage.l.get('auth');
	store.state.auth.self.token = auth.token;
	store.state.auth.self.username = auth.username;
	store.state.auth.self.roleId = auth.roleId;
	store.state.auth.self.userId = auth.userId;
	store.state.auth.authenticated = true;
	axios.defaults.headers.common.Authorization = `Bearer ${auth.token}`;
} else {
	router.replace({ name: 'login' })
}

new Vue({
	router,
	store,
	vuetify,
	eStorage,
	i18n,	
	// firebase,
	render: (h) => h(App),
}).$mount('#app');